import { Values } from '@lib/interfaces/form';
import {
  PERFORMANCE_LEGEND_BY_SECTOR_ANOMALIES,
  PERFORMANCE_LEGEND_BY_SECTOR_PERFORMANCE,
  PERFORMANCE_LEGEND_BY_SITE_ANOMALIES,
  PERFORMANCE_LEGEND_BY_SITE_PERFORMANCE,
} from '../constants';
import getLegendFilterName from './getLegendFilterName';
import getStatusKind from './getStatusKind';
import { MonitoringEntity, MonitoringType } from '../enums';
import { PerformanceLegend } from '../types';

export default function getLegendData({
  monitoringEntity,
  monitoringType,
  filterParams,
}: {
  monitoringEntity: MonitoringEntity;
  monitoringType: MonitoringType;
  filterParams: Values;
}) {
  // Legend is keyed by entity + type, and for anomaly also by status kind
  if (monitoringType === MonitoringType.Anomaly) {
    const statusKind = getStatusKind({ filterParams });
    const name = getLegendFilterName(
      monitoringEntity,
      monitoringType,
      statusKind,
    );
    const saved = filterParams[name];
    if (saved) return saved as PerformanceLegend;
    // Fallback defaults per entity for anomalies (same thresholds by default)
    return monitoringEntity === MonitoringEntity.Site
      ? PERFORMANCE_LEGEND_BY_SITE_ANOMALIES
      : PERFORMANCE_LEGEND_BY_SECTOR_ANOMALIES;
  }
  // Performance legends remain per entity
  const perfName = getLegendFilterName(monitoringEntity, monitoringType);
  const savedPerf = filterParams[perfName];
  if (savedPerf) return savedPerf as PerformanceLegend;
  return monitoringEntity === MonitoringEntity.Site
    ? PERFORMANCE_LEGEND_BY_SITE_PERFORMANCE
    : PERFORMANCE_LEGEND_BY_SECTOR_PERFORMANCE;
}
